import { render, staticRenderFns } from "./PlayButtonText.vue?vue&type=template&id=a8049b6a&"
import script from "./PlayButtonText.vue?vue&type=script&lang=js&"
export * from "./PlayButtonText.vue?vue&type=script&lang=js&"
import style0 from "./PlayButtonText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports